const formatDateID = (ymd, withWeekday = false) => {
  if (!ymd) return "";
  const [y, m, d] = String(ymd).split("-").map(Number);
  if (!y || !m || !d) return "";

  const dt = new Date(y, m - 1, d);

  const opt = withWeekday
    ? { weekday: "long", day: "2-digit", month: "long", year: "numeric" }
    : { day: "2-digit", month: "long", year: "numeric" };

  return new Intl.DateTimeFormat("id-ID", opt).format(dt);
};

(function () {
  const page = document.querySelector("[data-hotel-page]");
  if (!page) return;

  // ===== Scroll lock (prevent background scroll when dialog open) =====
  let hpScrollLockCount = 0;
  let hpSavedScrollY = 0;

  const lockBodyScroll = () => {
    hpScrollLockCount += 1;
    if (hpScrollLockCount > 1) return;

    hpSavedScrollY = window.scrollY || 0;

    // lock via fixed body (robust, works well on iOS)
    document.documentElement.classList.add("hp-scroll-locked");
    document.body.style.position = "fixed";
    document.body.style.top = `-${hpSavedScrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
  };

  const unlockBodyScroll = () => {
    hpScrollLockCount = Math.max(0, hpScrollLockCount - 1);
    if (hpScrollLockCount !== 0) return;

    document.documentElement.classList.remove("hp-scroll-locked");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";

    window.scrollTo(0, hpSavedScrollY || 0);
  };

  const ensureDialogCloseHook = (dlg) => {
    if (!dlg || dlg.dataset.hpScrollHook === "1") return;
    dlg.dataset.hpScrollHook = "1";

    // If user closes dialog via ESC, this will still run
    dlg.addEventListener("close", () => {
      if (dlg.dataset.hpScrollLocked === "1") {
        dlg.dataset.hpScrollLocked = "0";
        unlockBodyScroll();
      }
    });
  };

  const openDialog = (dlg) => {
    if (!dlg) return;

    ensureDialogCloseHook(dlg);

    if (dlg.dataset.hpScrollLocked !== "1") {
      dlg.dataset.hpScrollLocked = "1";
      lockBodyScroll();
    }

    if (typeof dlg.showModal === "function") dlg.showModal();
    else dlg.setAttribute("open", "");
  };

  const closeDialog = (dlg) => {
    if (!dlg) return;

    if (typeof dlg.close === "function") {
      // will trigger "close" event -> unlock happens there
      dlg.close();
    } else {
      dlg.removeAttribute("open");
      // no native close event here, so unlock manually
      if (dlg.dataset.hpScrollLocked === "1") {
        dlg.dataset.hpScrollLocked = "0";
        unlockBodyScroll();
      }
    }
  };

  const bindDialogBackdropClose = (dlg) => {
    if (!dlg) return;
    dlg.addEventListener("click", (e) => {
      if (e.target === dlg) closeDialog(dlg);
    });
  };

  // ===== Expand/Collapse: About =====
  (function initAboutToggle() {
    const aboutCard = page.querySelector("[data-hp-about]");
    if (!aboutCard) return;

    const content = aboutCard.querySelector("[data-hp-about-content]");
    const btn = aboutCard.querySelector("[data-hp-about-toggle]");
    if (!content || !btn) return;

    const collapsed = parseInt(aboutCard.dataset.collapsed || "160", 10);
    aboutCard.style.setProperty("--about-collapsed", `${collapsed}px`);

    const applyNeeds = () => {
      const needs = content.scrollHeight > collapsed + 24;
      btn.hidden = !needs;

      if (needs) {
        aboutCard.classList.add("has-toggle");
        btn.textContent = aboutCard.classList.contains("is-expanded") ? "Tutup" : "Lihat selengkapnya";
      } else {
        aboutCard.classList.remove("has-toggle");
        aboutCard.classList.remove("is-expanded");
        btn.textContent = "Lihat selengkapnya";
      }
    };

    requestAnimationFrame(applyNeeds);
    window.addEventListener("load", applyNeeds, { once: true });

    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(() => applyNeeds());
      ro.observe(content);
    }

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const expanded = aboutCard.classList.toggle("is-expanded");
      btn.textContent = expanded ? "Tutup" : "Lihat selengkapnya";
    });
  })();

  // ===== Expand/Collapse: Amenities =====
  (function initAmenitiesToggle() {
    const card = page.querySelector("[data-hp-amenities]");
    if (!card) return;

    const content = card.querySelector("[data-hp-amenities-content]");
    const btn = card.querySelector("[data-hp-amenities-toggle]");
    if (!content || !btn) return;

    const collapsed = parseInt(card.dataset.collapsed || "200", 10);
    card.style.setProperty("--expand-collapsed", `${collapsed}px`);

    const applyNeeds = () => {
      const needs = content.scrollHeight > collapsed + 24;
      btn.hidden = !needs;

      if (needs) {
        card.classList.add("has-toggle");
        btn.textContent = card.classList.contains("is-expanded") ? "Tutup" : "Lihat selengkapnya";
      } else {
        card.classList.remove("has-toggle");
        card.classList.remove("is-expanded");
        btn.textContent = "Lihat selengkapnya";
      }
    };

    requestAnimationFrame(applyNeeds);
    window.addEventListener("load", applyNeeds, { once: true });

    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(() => applyNeeds());
      ro.observe(content);
    }

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const expanded = card.classList.toggle("is-expanded");
      btn.textContent = expanded ? "Tutup" : "Lihat selengkapnya";
    });
  })();

  // ===== Main photo modal =====
  const photoModal = page.querySelector("[data-hp-photo-modal]");
  const photoOpenBtn = page.querySelector("[data-hp-open-photos]");
  const photoCloseBtn = page.querySelector("[data-hp-close-photos]");

  if (photoOpenBtn && photoModal) {
    photoOpenBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      openDialog(photoModal);
    });
  }

  if (photoCloseBtn && photoModal) {
    photoCloseBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeDialog(photoModal);
    });
  }

  bindDialogBackdropClose(photoModal);

  // ===== Booking =====
  const book = page.querySelector("[data-hp-book]");
  if (!book) return;

  const dataEl = book.querySelector("[data-hp-variants]");
  let vData = {
    variants: [],
    currency: "IDR",
    opt1Name: "Option 1",
    opt2Name: "",
    opt3Name: "",
  };

  try {
    vData = JSON.parse(dataEl?.textContent || "") || vData;
  } catch (e) {}

  const norm = (s) => (s ?? "").toString().trim();

  // UI refs
  const checkIn = book.querySelector("[data-hp-checkin]");
  const checkOut = book.querySelector("[data-hp-checkout]");

  const checkInWrap = checkIn?.closest(".hp-input");
  const checkOutWrap = checkOut?.closest(".hp-input");

  const markDateError = () => {
    [checkInWrap, checkOutWrap].forEach((w) => {
      if (!w) return;
      w.classList.add("is-date-error");
      w.classList.remove("is-shaking");
      void w.offsetWidth; // reflow
      w.classList.add("is-shaking");
      window.setTimeout(() => w.classList.remove("is-shaking"), 450);
    });
  };

  const clearDateError = () => {
    [checkInWrap, checkOutWrap].forEach((w) => {
      if (!w) return;
      w.classList.remove("is-date-error");
      w.classList.remove("is-shaking");
    });
  };

  const scrollToDateInputs = () => {
    // Fokus ke yang kosong dulu (check-in prioritas)
    const targetInput = !checkIn?.value ? checkIn : !checkOut?.value ? checkOut : checkIn;

    const targetWrap = targetInput?.closest(".hp-input") || targetInput;
    if (!targetWrap) return;

    // Scroll biar inputnya terlihat jelas
    targetWrap.scrollIntoView({ behavior: "smooth", block: "center" });

    // Fokus saja (tanpa buka dropdown/picker)
    window.setTimeout(() => {
      try {
        // flag supaya initAutoOpenDatePicker tidak memanggil showPicker
        targetInput?.setAttribute("data-hp-skip-picker", "1");

        targetInput?.focus({ preventScroll: true });

        // hapus flag setelah sebentar
        window.setTimeout(() => {
          targetInput?.removeAttribute("data-hp-skip-picker");
        }, 600);
      } catch (e) {}
    }, 250);
  };

  const scrollToGuestPill = () => {
    if (!pillEl) return;

    pillEl.scrollIntoView({ behavior: "smooth", block: "center" });

    window.setTimeout(() => {
      try {
        // ✅ aktifkan flag supaya "click" tidak membuka dropdown
        pillEl.setAttribute("data-hp-skip-open", "1");

        // fokus saja
        pillEl.focus({ preventScroll: true });

        // hapus flag setelah sebentar
        window.setTimeout(() => {
          pillEl.removeAttribute("data-hp-skip-open");
        }, 600);
      } catch (e) {}
    }, 250);
  };

  const nightsEl = book.querySelector("[data-hp-nights]");
  const totalEl = book.querySelector("[data-hp-total]");
  const totalEl2 = book.querySelector("[data-hp-total-2]");

  const selSummary = book.querySelector("[data-hp-selection-summary]");
  const selVariant = book.querySelector("[data-hp-sum-variant]");
  const selDates = book.querySelector("[data-hp-sum-dates]");
  const selGuests = book.querySelector("[data-hp-sum-guests]");

  const reserveBtn = book.querySelector("[data-hp-reserve]");
  const waNote = page.querySelector("[data-hp-wa-note]");
  const errorEl = book.querySelector("[data-hp-error]");

  const pillEl = book.querySelector("[data-hp-pill]");
  const guestDD = book.querySelector("[data-hp-guest-dd]");
  const guestCloseBtn = book.querySelector("[data-hp-guest-close]");
  const guestApplyBtn = book.querySelector("[data-hp-guest-apply]");
  const roomsInput = book.querySelector("[data-hp-rooms]");
  const adultsInput = book.querySelector("[data-hp-adults]");
  const childrenInput = book.querySelector("[data-hp-children]");
  const guestsHint = book.querySelector("[data-hp-guests-hint]");

  const incBtns = Array.from(book.querySelectorAll("[data-hp-inc]") || []);
  const decBtns = Array.from(book.querySelectorAll("[data-hp-dec]") || []);

  const roomTitle = book.querySelector("[data-hp-room-title]");
  const roomMeta = book.querySelector("[data-hp-room-meta]");
  const roomCards = Array.from(book.querySelectorAll("[data-hp-room-card]"));

  const opt2Radios = Array.from(book.querySelectorAll('input[type="radio"][data-hp-opt2]') || []);
  const opt3Radios = Array.from(book.querySelectorAll('input[type="radio"][data-hp-opt3]') || []);

  const state = {
    opt1: "",
    opt2: norm(opt2Radios.find((r) => r.checked)?.value || ""),
    opt3: norm(opt3Radios.find((r) => r.checked)?.value || ""),
    rooms: parseInt(roomsInput?.value, 10) || 1,
    adults: parseInt(adultsInput?.value, 10) || 2,
    children: parseInt(childrenInput?.value, 10) || 0,
    checkinYmd: "",
    checkoutYmd: "",
    maxGuests: 0,

    // Child-free rules (from variant JSON)
    childFree: false,
    childFreeQty: 0, // qty 0 berarti TIDAK ADA child free
  };

  // ===== Date helpers (native <input type="date">) =====
  const pad2 = (n) => String(n).padStart(2, "0");

  const ymdFromDate = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

  const dateFromYmd = (ymd) => {
    if (!ymd) return null;
    const [y, m, day] = ymd.split("-").map((x) => parseInt(x, 10));
    if (!y || !m || !day) return null;
    const d = new Date(y, m - 1, day);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const addDays = (d, days) => {
    const x = new Date(d);
    x.setDate(x.getDate() + days);
    x.setHours(0, 0, 0, 0);
    return x;
  };

  const startOfToday = () => {
    const t = new Date();
    t.setHours(0, 0, 0, 0);
    return t;
  };

  // RULE: kemarin & hari ini tidak bisa dipilih => min check-in = besok
  const MIN_CHECKIN_YMD = ymdFromDate(addDays(startOfToday(), 1));

  const variants = Array.isArray(vData.variants) ? vData.variants : [];

  const showError = (msg) => {
    if (!errorEl) return;
    errorEl.textContent = msg || "";
    errorEl.style.display = msg ? "block" : "none";
  };

  const formatIDRNoSymbol = (cents) => {
    const n = Number(cents || 0) / 100;
    return new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 }).format(n);
  };

  const parseYMD = (ymd) => {
    const [y, m, d] = norm(ymd).split("-").map(Number);
    if (!y || !m || !d) return null;
    const dt = new Date(y, m - 1, d);
    dt.setHours(0, 0, 0, 0);
    return dt;
  };

  const diffNights = (a, b) => {
    if (!a || !b) return 0;
    const n = Math.round((b.getTime() - a.getTime()) / 86400000);
    return n > 0 ? n : 0;
  };

  // Total tamu "fisik" (untuk display/WA)
  const totalGuests = () => Number(state.adults || 0) + Number(state.children || 0);

  // Eligible kalau variant mengizinkan child-free, qty > 0, dan adults >= 2
  const isChildFreeEligible = () =>
    !!state.childFree && Number(state.childFreeQty || 0) > 0 && Number(state.adults || 0) >= 2;

  // total anak yang "gratis/tidak dihitung" untuk booking ini
  const freeChildAllowance = () => {
    if (!isChildFreeEligible()) return 0;

    const perRoom = Number(state.childFreeQty || 0);
    if (perRoom <= 0) return 0;

    const rooms = Math.max(1, Number(state.rooms || 1));
    return perRoom * rooms;
  };

  // total tamu yang dihitung untuk validasi kapasitas
  const capacityGuestsCount = () => {
    const adults = Number(state.adults || 0);
    const children = Number(state.children || 0);
    const free = Math.min(children, freeChildAllowance());
    return adults + (children - free);
  };

  // ===== soft disable (jangan pakai disabled utk capacity; click harus tetap jalan buat shake) =====
  const softDisable = (btn, on) => {
    if (!btn) return;
    btn.classList.toggle("is-disabled", !!on);
    btn.setAttribute("aria-disabled", on ? "true" : "false");
    if (btn.disabled) btn.disabled = false;
  };

  // ===== Capacity validation =====
  const capacityInfo = () => {
    const perRoom = Number(state.maxGuests || 0);
    const rooms = Math.max(1, Number(state.rooms || 1));
    const allowed = perRoom ? perRoom * rooms : 0;

    const tg = capacityGuestsCount();
    const free = Math.min(Number(state.children || 0), freeChildAllowance());
    const over = perRoom > 0 && tg > allowed;

    return { perRoom, rooms, allowed, tg, over, free };
  };

  const capacityErrorText = () => {
    const c = capacityInfo();
    if (!c.over) return "";
    const note = c.free > 0 ? ` (Catatan: ${c.free} anak tidak dihitung)` : "";
    return `Total tamu terhitung (${c.tg}) melebihi kapasitas maksimum (${c.allowed}) untuk ${c.rooms} kamar ini.${note}`;
  };

  const showCapacityError = () => {
    if (!errorEl) return;
    errorEl.dataset.hpCapacity = "1";
    showError(capacityErrorText());
  };

  const clearCapacityError = () => {
    if (!errorEl) return;
    if (errorEl.dataset.hpCapacity === "1") {
      delete errorEl.dataset.hpCapacity;
      showError("");
    }
  };

  const markPillCapacityError = () => {
    if (!pillEl) return;

    pillEl.classList.add("is-capacity-error");
    pillEl.classList.remove("is-shaking");
    void pillEl.offsetWidth; // force reflow
    pillEl.classList.add("is-shaking");
    window.setTimeout(() => pillEl.classList.remove("is-shaking"), 450);
  };

  const clearPillCapacityError = () => {
    if (!pillEl) return;
    pillEl.classList.remove("is-capacity-error");
    pillEl.classList.remove("is-shaking");
  };

  const syncCapacityUI = () => {
    const c = capacityInfo();

    softDisable(guestApplyBtn, c.over);

    if (reserveBtn && reserveBtn.dataset.hpLoading !== "1") {
      softDisable(reserveBtn, c.over);
    }

    if (c.over) {
      showCapacityError();
      if (pillEl) pillEl.classList.add("is-capacity-error");
    } else {
      clearCapacityError();
      clearPillCapacityError();
    }
  };

  const clearErrorUnlessCapacity = () => {
    const c = capacityInfo();
    if (c.over) showCapacityError();
    else {
      if (errorEl) delete errorEl.dataset.hpCapacity;
      showError("");
    }
  };

  const clampState = () => {
    state.rooms = Math.max(1, Number(state.rooms || 1));
    state.adults = Math.max(1, Number(state.adults || 1));
    state.children = Math.max(0, Number(state.children || 0));
  };

  const syncDDInputs = () => {
    if (roomsInput) roomsInput.value = String(state.rooms);
    if (adultsInput) adultsInput.value = String(state.adults);
    if (childrenInput) childrenInput.value = String(state.children);
  };

  const updatePill = (nights) => {
    if (!pillEl) return;

    const c = capacityInfo();
    const freeTxt = c.free > 0 ? ` (${c.free} free)` : "";

    pillEl.textContent = `${state.rooms} room • ${state.adults} adult • ${state.children} child${freeTxt} • ${nights} malam`;
  };

  const updateGuestsHint = () => {
    if (!guestsHint) return;
    const c = capacityInfo();
    if (!c.perRoom) {
      guestsHint.textContent = "";
      return;
    }
    guestsHint.textContent = c.over ? capacityErrorText() : "";
  };

  const variantsForOpt1 = (opt1) => variants.filter((v) => norm(v.option1) === norm(opt1));

  const findVariant = () => {
    const wantsOpt2 = opt2Radios.length > 0;
    const wantsOpt3 = opt3Radios.length > 0;

    const exact = variants.find(
      (v) =>
        norm(v.option1) === norm(state.opt1) &&
        (!wantsOpt2 || norm(v.option2) === norm(state.opt2)) &&
        (!wantsOpt3 || norm(v.option3) === norm(state.opt3)),
    );
    if (exact) return exact;

    const list = variantsForOpt1(state.opt1);
    return list.find((v) => v.available) || list[0] || null;
  };

  const syncDetailForVariant = (variantId, { force = false } = {}) => {
    const activeCard = roomCards.find((c) => c.classList.contains("is-active"));
    if (!activeCard) return;

    const panel = activeCard.querySelector("[data-hp-room-detail]");
    if (!panel) return;

    if (!force && panel.hidden) return;

    const body = activeCard.querySelector("[data-hp-room-detail-body]");
    if (!body) return;

    const tpl = page.querySelector(`template[data-hp-variant-detail="${variantId}"]`);
    if (!tpl) return;

    body.querySelectorAll?.("dialog[open]")?.forEach?.((dlg) => closeDialog(dlg));

    body.innerHTML = "";
    body.appendChild(tpl.content.cloneNode(true));

    body.querySelectorAll?.("dialog[data-hp-room-photo-modal]")?.forEach?.((dlg) => bindDialogBackdropClose(dlg));
  };

  const refreshAvailability = () => {
    const list = variantsForOpt1(state.opt1);

    if (opt2Radios.length) {
      const validOpt2 = new Set(list.map((v) => norm(v.option2)).filter(Boolean));
      opt2Radios.forEach((r) => {
        const ok = validOpt2.size === 0 ? true : validOpt2.has(norm(r.value));
        r.disabled = !ok;
        const label = r.closest("label");
        if (label) label.classList.toggle("is-disabled", !ok);
      });

      const checked = opt2Radios.find((r) => r.checked && !r.disabled);
      if (!checked) {
        const first = opt2Radios.find((r) => !r.disabled);
        if (first) first.checked = true;
        state.opt2 = norm(first?.value || "");
      } else {
        state.opt2 = norm(checked.value);
      }
    }

    if (opt3Radios.length) {
      const wantsOpt2 = opt2Radios.length > 0;
      const list2 = wantsOpt2 ? list.filter((v) => norm(v.option2) === norm(state.opt2)) : list;

      const validOpt3 = new Set(list2.map((v) => norm(v.option3)).filter(Boolean));
      opt3Radios.forEach((r) => {
        const ok = validOpt3.size === 0 ? true : validOpt3.has(norm(r.value));
        r.disabled = !ok;
        const label = r.closest("label");
        if (label) label.classList.toggle("is-disabled", !ok);
      });

      const checked = opt3Radios.find((r) => r.checked && !r.disabled);
      if (!checked) {
        const first = opt3Radios.find((r) => !r.disabled);
        if (first) first.checked = true;
        state.opt3 = norm(first?.value || "");
      } else {
        state.opt3 = norm(checked.value);
      }
    }
  };

  // ✅ HOISTED: aman dipanggil dari updateSummary()
  function syncWABookingNote() {
    if (!waNote) return;

    const ci = state.checkinYmd;
    const co = state.checkoutYmd;
    const v = findVariant();

    const ready = !!ci && !!co && !!v;
    waNote.classList.toggle("is-hidden", !ready);
  }

  const updateSummary = () => {
    clampState();
    syncDDInputs();

    const ci = parseYMD(state.checkinYmd);
    const co = parseYMD(state.checkoutYmd);
    const nights = diffNights(ci, co);

    if (nightsEl) nightsEl.textContent = String(nights);

    if (roomTitle) roomTitle.textContent = state.opt1 || "Pilih kamar";
    if (roomMeta) {
      const metaParts = [];
      if (opt2Radios.length) metaParts.push(state.opt2 || "—");
      if (opt3Radios.length) metaParts.push(state.opt3 || "—");
      roomMeta.textContent = metaParts.join(" • ") || "—";
    }

    // --- Selection summary: SELALU TAMPIL ---
    if (selSummary) selSummary.hidden = false;

    const variantParts = [];
    if (state.opt1) variantParts.push(state.opt1);
    if (opt2Radios.length && state.opt2) variantParts.push(state.opt2);
    if (opt3Radios.length && state.opt3) variantParts.push(state.opt3);

    const variantText = variantParts.join(" • ") || "—";

    const datesText =
      state.checkinYmd && state.checkoutYmd
        ? `${formatDateID(state.checkinYmd)} – ${formatDateID(state.checkoutYmd)}`
        : "-";

    let guestsText = `${state.adults} dewasa`;
    if (state.children > 0) guestsText += `, ${state.children} anak`;
    guestsText += ` • ${state.rooms} kamar`;

    if (selVariant) selVariant.textContent = variantText;
    if (selDates) selDates.textContent = datesText;
    if (selGuests) selGuests.textContent = guestsText;

    const v = findVariant();

    // === Sync variant rules to state (maxGuests + child free flags) ===
    state.maxGuests = v ? Number(v.maxGuests || 0) : Number(state.maxGuests || 0);

    state.childFree = v ? !!v.childFree : false;
    state.childFreeQty = v ? Number(v.childFreeQty || 0) : 0;

    // ✅ TIDAK ADA AUTO-SET CHILDREN DI SINI (user yang kontrol jumlah anak)

    // Update pill AFTER syncing variant rules so it shows (x free) correctly
    updatePill(nights);

    if (!v || nights <= 0) {
      if (totalEl) totalEl.textContent = "—";
      if (totalEl2) totalEl2.textContent = "—";

      updateGuestsHint();
      syncCapacityUI();
      syncWABookingNote();
      return;
    }

    const total = v.price * nights * state.rooms;
    const formatted = formatIDRNoSymbol(total);

    if (totalEl) totalEl.textContent = formatted;
    if (totalEl2) totalEl2.textContent = formatted;

    syncDetailForVariant(v.id);

    updateGuestsHint();
    syncCapacityUI();
    syncWABookingNote();
  };

  const syncDateConstraints = (source = "init") => {
    if (!checkIn || !checkOut) return;

    // Set min check-in = besok (disable kemarin & hari ini)
    checkIn.min = MIN_CHECKIN_YMD;

    // Baca value sekarang
    let ciYmd = norm(checkIn.value);
    let coYmd = norm(checkOut.value);

    // Kalau user somehow isi check-in < besok, reset
    if (ciYmd && ciYmd < MIN_CHECKIN_YMD) {
      ciYmd = "";
      checkIn.value = "";
    }

    // Tentukan min check-out:
    // - kalau ada check-in: min = check-in + 1 hari
    // - kalau belum ada check-in: min = besok + 1 hari
    const baseForCO = ciYmd ? dateFromYmd(ciYmd) : addDays(startOfToday(), 1);
    const minCO = ymdFromDate(addDays(baseForCO, 1));
    checkOut.min = minCO;

    // Kalau checkout dipilih tapi < minCO, reset
    if (coYmd && coYmd < minCO) {
      coYmd = "";
      checkOut.value = "";
    }

    // Kalau ada check-out, batasi max check-in = check-out - 1 hari
    if (coYmd) {
      const maxCI = ymdFromDate(addDays(dateFromYmd(coYmd), -1));
      checkIn.max = maxCI;

      // Kalau check-in keburu > max, reset check-in
      if (ciYmd && ciYmd > maxCI) {
        ciYmd = "";
        checkIn.value = "";
      }
    } else {
      checkIn.removeAttribute("max");
    }

    // Auto-fix: kalau user pilih check-in, tapi checkout kosong / <= check-in => set otomatis H+1
    if (ciYmd) {
      const ciD = dateFromYmd(ciYmd);
      const autoCO = ymdFromDate(addDays(ciD, 1));

      if (!coYmd || coYmd <= ciYmd) {
        checkOut.value = autoCO;
        coYmd = autoCO;
      }

      // setelah auto set, pastikan constraint max check-in ikut update
      const maxCI = ymdFromDate(addDays(dateFromYmd(coYmd), -1));
      checkIn.max = maxCI;
    }

    // Update state
    state.checkinYmd = ciYmd;
    state.checkoutYmd = coYmd;

    updateSummary();
    clearErrorUnlessCapacity();
  };

  const setExpandedUI = (card, isOpen) => {
    const panel = card.querySelector("[data-hp-room-detail]");
    const btn = card.querySelector("[data-hp-room-toggle]");
    if (!panel || !btn) return;

    panel.hidden = !isOpen;
    btn.setAttribute("aria-expanded", String(isOpen));
    card.classList.toggle("is-expanded", isOpen);

    const t = btn.querySelector(".hp-room-card__toggleText");
    if (t) t.textContent = isOpen ? "Tutup" : "Detail Kamar";
  };

  const collapseOtherCards = (exceptCard) => {
    roomCards.forEach((c) => {
      if (c === exceptCard) return;
      setExpandedUI(c, false);
    });
  };

  const setActiveCard = (card) => {
    if (card.dataset.available === "false") {
      showError("Kamar ini tidak tersedia.");
      return;
    }

    state.opt1 = norm(card.dataset.opt1 || "");
    state.maxGuests = Number(card.dataset.maxGuests || 0);

    roomCards.forEach((c) => c.classList.toggle("is-active", c === card));
    collapseOtherCards(card);

    refreshAvailability();
    updateSummary();
    clearErrorUnlessCapacity();
  };

  const toggleRoomDetail = (card) => {
    const panel = card.querySelector("[data-hp-room-detail]");
    if (!panel) return;

    const nextOpen = panel.hidden;
    setExpandedUI(card, nextOpen);

    if (nextOpen) {
      const v = findVariant();
      if (v) syncDetailForVariant(v.id, { force: true });
    }
  };

  const shouldIgnoreCardClick = (target) => {
    const interactive = target.closest("a, button, input, textarea, select, label");
    if (!interactive) return false;
    if (interactive.closest("[data-hp-room-toggle]")) return false;
    return true;
  };

  roomCards.forEach((card) => {
    card.addEventListener("click", (e) => {
      const toggleBtn = e.target && e.target.closest("[data-hp-room-toggle]");
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();

        if (!card.classList.contains("is-active")) setActiveCard(card);
        toggleRoomDetail(card);
        return;
      }

      if (shouldIgnoreCardClick(e.target)) return;
      setActiveCard(card);
    });

    card.addEventListener("keydown", (e) => {
      if (e.key !== "Enter" && e.key !== " ") return;
      e.preventDefault();
      card.click();
    });
  });

  opt2Radios.forEach((r) => {
    r.addEventListener("change", () => {
      if (!r.checked) return;
      state.opt2 = norm(r.value);
      refreshAvailability();
      updateSummary();
      clearErrorUnlessCapacity();
    });
  });

  opt3Radios.forEach((r) => {
    r.addEventListener("change", () => {
      if (!r.checked) return;
      state.opt3 = norm(r.value);
      updateSummary();
      clearErrorUnlessCapacity();
    });
  });

  const openDD = () => {
    if (guestDD) guestDD.hidden = false;
  };
  const closeDD = () => {
    if (guestDD) guestDD.hidden = true;
  };
  const toggleDD = () => {
    if (guestDD) guestDD.hidden ? openDD() : closeDD();
  };

  pillEl?.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();

    // ✅ kalau lagi di-mode "skip", jangan buka dropdown
    if (pillEl.getAttribute("data-hp-skip-open") === "1") return;

    toggleDD();
  });

  guestCloseBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    closeDD();
  });

  guestApplyBtn?.addEventListener("click", (e) => {
    e.preventDefault();

    // pastikan summary terbaru dulu
    updateSummary();

    if (capacityInfo().over) {
      showCapacityError();
      markPillCapacityError();
      scrollToGuestPill(); // ✅ scroll+focus tanpa buka dropdown
      return;
    }

    clearErrorUnlessCapacity();
    closeDD();
  });

  const adjust = (field, delta) => {
    state[field] = Number(state[field] || 0) + delta;
    updateSummary();
    clearErrorUnlessCapacity();
  };

  incBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const field = btn.dataset.hpInc;
      if (!field) return;
      adjust(field, +1);
    });
  });

  decBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const field = btn.dataset.hpDec;
      if (!field) return;
      adjust(field, -1);
    });
  });

  document.addEventListener("click", (e) => {
    if (!guestDD || guestDD.hidden) return;
    const t = e.target;
    if (guestDD.contains(t) || (pillEl && pillEl.contains(t))) return;
    closeDD();
  });

  checkIn?.addEventListener("change", () => {
    if (checkInWrap) checkInWrap.classList.remove("is-date-error");
    syncDateConstraints("checkin");
  });

  checkOut?.addEventListener("change", () => {
    if (checkOutWrap) checkOutWrap.classList.remove("is-date-error");
    syncDateConstraints("checkout");
  });

  // Room photo modal inside variant detail
  page.addEventListener("click", (e) => {
    const openBtn = e.target?.closest?.("[data-hp-open-room-photos]");
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();

      const scope =
        openBtn.closest("[data-hp-room-gallery]") || openBtn.closest("[data-hp-room-detail]") || openBtn.parentElement;

      const dlg = scope?.querySelector?.("dialog[data-hp-room-photo-modal]");
      openDialog(dlg);
      return;
    }

    const closeBtn = e.target?.closest?.("[data-hp-close-room-photos]");
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();

      const dlg = closeBtn.closest("dialog[data-hp-room-photo-modal]");
      closeDialog(dlg);
      return;
    }
  });

  // ===== WA BOOKING =====
  const WA_NUMBER = "628112346680";

  const buildWhatsAppUrl = (text) => {
    const base = `https://wa.me/${WA_NUMBER}`;
    return `${base}?text=${encodeURIComponent(text)}`;
  };

  reserveBtn?.addEventListener("click", (e) => {
    e.preventDefault();

    try {
      // pastikan summary terbaru dulu
      updateSummary();

      if (capacityInfo().over) {
        showCapacityError();
        markPillCapacityError();
        scrollToGuestPill(); // ✅ scroll+focus tanpa buka dropdown
        throw new Error(capacityErrorText());
      }

      showError("");

      const ci = parseYMD(state.checkinYmd);
      const co = parseYMD(state.checkoutYmd);
      const nights = diffNights(ci, co);

      clearDateError();

      if (!ci || !co) {
        markDateError();
        scrollToDateInputs();
        throw new Error("Harap pilih tanggal check-in dan check-out.");
      }
      if (nights <= 0) {
        markDateError();
        scrollToDateInputs();
        throw new Error("Tanggal check-out harus setelah check-in.");
      }

      const v = findVariant();
      if (!v) throw new Error("Variant tidak ditemukan untuk kombinasi pilihan ini.");
      if (!v.available) throw new Error("Variant ini sedang tidak tersedia.");

      const qty = nights * state.rooms;
      if (qty <= 0) throw new Error("Quantity tidak valid.");

      const productTitle = norm(page.querySelector(".hp-title")?.textContent || "Hotel");
      const roomName = state.opt1 || "-";
      const opt2Text = opt2Radios.length ? state.opt2 || "" : "";
      const opt3Text = opt3Radios.length ? state.opt3 || "" : "";

      const total = v.price * nights * state.rooms;
      const totalFormatted = formatIDRNoSymbol(total);

      const checkinText = formatDateID(state.checkinYmd, true);
      const checkoutText = formatDateID(state.checkoutYmd, true);

      const c = capacityInfo();
      const physicalTotal = totalGuests();
      const countedTotal = c.tg;
      const freeNote = c.free > 0 ? ` (termasuk ${c.free} anak free, tidak dihitung)` : "";

      const lines = [
        "Halo Admin, saya mau booking : \n",
        `Nama Hotel : *${productTitle}*`,
        `Varian Kamar : *${roomName}${opt2Text ? ` • ${opt2Text}` : ""}${opt3Text ? ` • ${opt3Text}` : ""}*`,
        `Tanggal Check-in : ${checkinText}`,
        `Tanggal Check-out : ${checkoutText}`,
        `Jumlah Malam : ${nights} malam`,
        `Jumlah Rooms : ${state.rooms} kamar`,
        `Jumlah Tamu Dewasa : ${state.adults} orang`,
        `Jumlah Tamu Anak 0-11 : ${state.children} orang`,
        `Total tamu : ${physicalTotal} orang • terhitung kapasitas: ${countedTotal}${freeNote}\n`,
        `Estimasi total harga : Rp. ${totalFormatted}\n`,
        "Mohon info ketersediaan & langkah selanjutnya ya. Terima kasih",
      ].filter(Boolean);

      const waUrl = buildWhatsAppUrl(lines.join("\n"));
      window.open(waUrl, "_blank", "noopener,noreferrer");
    } catch (err) {
      showError(err?.message || "Terjadi error.");
    } finally {
      syncCapacityUI();
    }
  });

  if (roomCards.length > 0) {
    const first = roomCards.find((c) => c.dataset.available !== "false") || roomCards[0];
    setActiveCard(first);
  } else {
    updateSummary();
  }

  syncDateConstraints("init");
})();

(function initAutoOpenDatePicker() {
  const isDateInput = (el) => el && el.tagName === "INPUT" && el.type === "date" && !el.disabled && !el.readOnly;

  const tryShow = (el) => {
    if (!isDateInput(el)) return false;

    if (el?.getAttribute("data-hp-skip-picker") === "1") return false;

    if (typeof el.showPicker === "function") {
      try {
        el.showPicker();
        return true;
      } catch (e) {
        return false;
      }
    }
    return false;
  };

  document.addEventListener(
    "pointerdown",
    (e) => {
      const el = e.target?.closest?.('input[type="date"]');
      if (!el) return;

      requestAnimationFrame(() => {
        el.focus({ preventScroll: true });
        tryShow(el);
      });
    },
    true,
  );

  document.addEventListener(
    "mousedown",
    (e) => {
      const el = e.target?.closest?.('input[type="date"]');
      if (!el) return;

      requestAnimationFrame(() => {
        el.focus({ preventScroll: true });
        tryShow(el);
      });
    },
    true,
  );

  document.addEventListener(
    "focusin",
    (e) => {
      const el = e.target;
      tryShow(el);
    },
    true,
  );
})();

// Google reviews hotel
document.addEventListener("DOMContentLoaded", () => {
  const wrap = document.querySelector("[data-google-reviews]");
  if (!wrap) return;

  const placeId = wrap.dataset.placeId;
  if (!placeId) return;

  const endpoint = `https://api.japantrips.id/reviews?place_id=${encodeURIComponent(placeId)}`;
  const mapsUrl = `https://www.google.com/maps/place/?q=place_id:${encodeURIComponent(placeId)}`;

  // ===== Carousel elements (inside wrap) =====
  const ratingEl = wrap.querySelector("[data-gr-rating]");
  const countEl = wrap.querySelector("[data-gr-count]");
  const trackEl = wrap.querySelector("[data-gr-track]");
  const dotsEl = wrap.querySelector("[data-gr-dots]");
  const prevBtn = wrap.querySelector("[data-gr-prev]");
  const nextBtn = wrap.querySelector("[data-gr-next]");
  const moreEl = wrap.querySelector("[data-gr-more]");

  const ratingLinkEl = document.querySelector("[data-hp-rating-link]");
  const score10El = document.querySelector("[data-hp-rating-score]");
  const labelEl = document.querySelector("[data-hp-rating-label]");
  const snippetEl = document.querySelector("[data-hp-rating-text]");
  const allCountEl = document.querySelector("[data-hp-rating-count]");

  if (moreEl) moreEl.setAttribute("href", mapsUrl);
  if (ratingLinkEl) {
    ratingLinkEl.setAttribute("href", "#google-reviews");
    ratingLinkEl.addEventListener("click", (e) => {
      e.preventDefault();
      const target = document.getElementById("google-reviews");
      if (!target) return;
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  const esc = (str) =>
    String(str ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const starsHtml = (n) => {
    const r = Math.max(0, Math.min(5, Number(n) || 0));
    return Array.from({ length: 5 })
      .map((_, i) => `<span class="gr-star ${i < r ? "is-on" : ""}">★</span>`)
      .join("");
  };

  const initials = (name) => {
    const parts = String(name || "G")
      .trim()
      .split(/\s+/)
      .slice(0, 2);
    return parts.map((p) => p[0]?.toUpperCase() || "").join("") || "G";
  };

  const clampText = (t, max = 260) => {
    const s = String(t || "").trim();
    if (s.length <= max) return s;
    return s.slice(0, max - 1) + "…";
  };

  const labelFromScore10 = (s) => {
    const v = Number(s) || 0;
    if (v >= 9.0) return "Exceptional";
    if (v >= 8.0) return "Very good";
    if (v >= 7.0) return "Good";
    if (v >= 6.0) return "Pleasant";
    return "Review score";
  };

  let dotButtons = [];

  const setDots = (pageCount) => {
    if (!dotsEl) return;
    dotsEl.innerHTML = "";
    dotButtons = [];

    for (let i = 0; i < pageCount; i++) {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "gr-dot" + (i === 0 ? " is-active" : "");
      b.setAttribute("aria-label", `Go to page ${i + 1}`);
      b.addEventListener("click", () => {
        if (!trackEl) return;
        const w = trackEl.clientWidth || 1;
        trackEl.scrollTo({ left: i * w, behavior: "smooth" });
      });
      dotsEl.appendChild(b);
      dotButtons.push(b);
    }
  };

  const activateDotByScroll = () => {
    if (!trackEl || !dotButtons.length) return;
    const w = trackEl.clientWidth || 1;
    const page = Math.round(trackEl.scrollLeft / w);
    dotButtons.forEach((b, i) => b.classList.toggle("is-active", i === page));
  };

  const bindNav = () => {
    if (!trackEl) return;

    prevBtn?.addEventListener("click", () => {
      const w = trackEl.clientWidth || 1;
      trackEl.scrollBy({ left: -w, behavior: "smooth" });
    });

    nextBtn?.addEventListener("click", () => {
      const w = trackEl.clientWidth || 1;
      trackEl.scrollBy({ left: w, behavior: "smooth" });
    });

    trackEl.addEventListener("scroll", () => {
      window.requestAnimationFrame(activateDotByScroll);
    });

    window.addEventListener("resize", () => {
      if (!trackEl) return;
      activateDotByScroll();
      const pages = Math.max(1, Math.ceil(trackEl.scrollWidth / (trackEl.clientWidth || 1)));
      setDots(pages);
      activateDotByScroll();
    });
  };

  fetch(endpoint)
    .then((r) => r.json())
    .then((data) => {
      // ===== validate =====
      if (!data || typeof data.rating !== "number") {
        if (trackEl) trackEl.innerHTML = `<div class="muted">No reviews available.</div>`;
        if (score10El) score10El.textContent = `—/10`;
        if (labelEl) labelEl.textContent = `—`;
        if (snippetEl) snippetEl.textContent = `No reviews available.`;
        if (allCountEl) allCountEl.textContent = `All reviews`;
        return;
      }

      const rating = Number(data.rating || 0);
      const count = Number(data.userRatingCount || 0);

      if (ratingEl) {
        ratingEl.innerHTML = `${rating.toFixed(1)}/5 <span class="gr-google__star" aria-hidden="true">★</span>`;
      }
      if (countEl) countEl.textContent = `Based on ${count} reviews`;
      const score5 = Math.round(rating * 10) / 10;
      if (score10El) score10El.textContent = `${score5}/5`;

      const labelFromScore5 = (s) => {
        const v = Number(s) || 0;
        if (v >= 4.5) return "Exceptional";
        if (v >= 4.0) return "Very good";
        if (v >= 3.5) return "Good";
        if (v >= 3.0) return "Pleasant";
        return "Review score";
      };

      if (labelEl) labelEl.textContent = labelFromScore5(score5);

      const allReviews = Array.isArray(data.reviews) ? data.reviews : [];
      const firstWithText = allReviews.find((r) => (r?.text?.text || "").trim().length);
      const snippet = firstWithText?.text?.text || "";
      if (snippetEl) snippetEl.textContent = snippet ? clampText(snippet, 360) : "No review text available.";
      if (allCountEl) allCountEl.textContent = `All ${count.toLocaleString("en-US")} reviews`;

      if (!trackEl) return;

      const sorted = allReviews.slice().sort((a, b) => (Number(b.rating) || 0) - (Number(a.rating) || 0));

      const take = sorted.slice(0, 12);

      if (!take.length) {
        trackEl.innerHTML = `<div class="muted">No reviews available.</div>`;
        return;
      }

      trackEl.innerHTML = take
        .map((r) => {
          const name = r.authorAttribution?.displayName || "Guest";
          const text = r.text?.text || "";
          const stars = Number(r.rating) || 0;
          const time = r.relativePublishTimeDescription || "";
          const photo = r.authorAttribution?.photoUri || "";

          const avatar = photo ? `<img src="${esc(photo)}" alt="${esc(name)}" loading="lazy">` : esc(initials(name));

          return `
            <a class="gr-card" href="${mapsUrl}" target="_blank" rel="noopener noreferrer">
              <p class="gr-card__text">${esc(clampText(text))}</p>

              <div class="gr-card__metaRow">
                <div class="gr-stars" aria-label="${stars} out of 5 stars">
                  ${starsHtml(stars)}
                </div>
              </div>

              <div class="gr-author">
                <div class="gr-avatar">${avatar}</div>
                <div>
                  <div class="gr-author__name">${esc(name)}</div>
                  <div class="gr-author__time">${esc(time)}</div>
                </div>
              </div>
            </a>
          `;
        })
        .join("");

      const pages = Math.max(1, Math.ceil(trackEl.scrollWidth / (trackEl.clientWidth || 1)));
      setDots(pages);
      bindNav();
      activateDotByScroll();
    })
    .catch(() => {
      if (trackEl) trackEl.innerHTML = `<div class="muted">Failed to load reviews.</div>`;
      if (snippetEl) snippetEl.textContent = `Failed to load rating.`;
    });
});
